var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 256 256",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.718 69.333l-29.842-13.128H97.003l-29.66 13.372-24.676 27.41L128 210.463l85.333-113.474-24.615-27.655zm17.504 28.39l-26.986 20.194-19.19-28.755 27.152-12.778 19.024 21.34zm-36.893 23.272H85.09l16.766-29.781 50.212.121 17.261 29.66zm-66.8-60.346h51.401l25.306 11.16-25.414 11.07h-51.4L77.263 71.818l25.267-11.17zM68.745 76.384l25.463 12.763-18.234 28.202L49.72 97.723l19.024-21.34zm-9.24 36.207l16.59 13.989 39.472 64.956-56.063-78.945zm27.886 17.643h79.985L128 202.804l-40.61-72.57zm52.986 61.302l39.472-64.956 16.59-13.989-56.062 78.945z",
    fill: "#36CEF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.d82b4abd04e5d7545145fcfcaf448e44.svg";
export { ForwardRef as ReactComponent };